import type { $Fetch } from 'ofetch';
import type { MeGateway } from '@/application/port/out/MeGateway';
import type { ManagedUser } from '@/domain/model/ManagedUser';
import type { TotpSetup, UpdateMeCommand, ChangePasswordCommand } from '@/domain/model/MeAccount';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

const ROOT = '/api/v1/me';

/** HTTP gateway do self-service do usuário autenticado (perfil/senha/2FA). */
export class HttpMeGateway implements MeGateway {
  constructor(private readonly client: $Fetch) {}

  async getMe(): Promise<ManagedUser> {
    const res = await this.client<ApiResponse<ManagedUser>>(ROOT, { method: 'GET' });
    assertApiSuccess(res);
    return res.data;
  }

  async updateMe(cmd: UpdateMeCommand): Promise<ManagedUser> {
    const res = await this.client<ApiResponse<ManagedUser>>(ROOT, { method: 'PATCH', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }

  async changePassword(cmd: ChangePasswordCommand): Promise<void> {
    // BE 204 No Content.
    await this.client<void>(`${ROOT}/password`, { method: 'PUT', body: cmd });
  }

  async setupTotp(): Promise<TotpSetup> {
    const res = await this.client<ApiResponse<TotpSetup>>(`${ROOT}/totp/setup`, { method: 'POST' });
    assertApiSuccess(res);
    return res.data;
  }

  async enableTotp(code: string): Promise<void> {
    // BE 204 No Content.
    await this.client<void>(`${ROOT}/totp/enable`, { method: 'POST', body: { code } });
  }

  async disableTotp(currentPassword: string, code: string): Promise<void> {
    // BE 204 No Content. DELETE com body (senha + código).
    await this.client<void>(`${ROOT}/totp`, { method: 'DELETE', body: { currentPassword, code } });
  }
}
